var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lp-contacts-details',{attrs:{"work-type":"수탁계좌"}}),_c('lp-contacts-details',{attrs:{"work-type":"업무담당자"}}),_c('lp-contacts-details',{attrs:{"work-type":"LP담당자"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }